import { LANDING_PRINT_PAGES } from 'constants/navigation';

export const getIsGoodsLabelPage = (pageName: string) => Object.keys(LANDING_PRINT_PAGES).includes(pageName);
